import { makeStyles } from "@mui/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: "calc(100vw - 240px)",
    minHeight: "100vh",
    overflow: "scroll",
    "@media (max-width: 550px)": {
      padding: "14px",
      paddingTop: "20px"
    }
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  fakeToolbar: {
    ...theme.mixins.toolbar
  },
  link: {
    "&:not(:first-child)": {
      paddingLeft: 15
    }
  }
}));
